"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DoubleTemperatureSensorModelContent = exports.DoubleTemperatureSensorModel = void 0;
var _react = _interopRequireDefault(require("react"));
var _drei = require("@react-three/drei");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _reactErrorBoundary = require("react-error-boundary");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../../utils/constants");
var _Types = require("../../../Types");
const _excluded = ["activeCable", "deviceRotate", "thingPDIDDevice"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const DoubleTemperatureSensorModelContent = _ref => {
  let {
      activeCable = _constants.activeCableDirection.vertical,
      deviceRotate = [0, 0, 0],
      thingPDIDDevice
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    source
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const {
    nodes,
    materials
  } = (0, _drei.useGLTF)("".concat(source).concat(_constants.webGLModalsSource, "/100_paul_assets/107_paul_doubleSensor.glb"));
  const shadows = {
    castShadow: true,
    receiveShadow: false
  };
  return /*#__PURE__*/_react.default.createElement("group", _extends({}, props, {
    dispose: null,
    rotation: deviceRotate
  }), activeCable === _constants.activeCableDirection.horizontal && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['21_vertical_connectors'].geometry,
    material: materials['Component.WhiteDefault'],
    position: [0.5, 4, 2.8],
    rotation: [0, -1.57, 0]
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['22_vertical_cables'].geometry,
    material: materials['Component.BodyBlack'],
    position: [0.5, 4, 2.8],
    rotation: [-Math.PI / 2, 0, -Math.PI / 2]
  }, shadows))), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['01_horizontal_paulLogo'].geometry,
    material: materials['Component.EmissionBlau'],
    position: [2.5, 6.4, 2.91],
    rotation: [1.57, 0, -1.57],
    scale: 0.91
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['02_horizontal_label'].geometry,
    material: materials['Component.LabelBlueDark'],
    position: [2.57, 6.1, 2.8],
    rotation: [-Math.PI / 2, 0, -Math.PI / 2]
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['03_horizontal_topper'].geometry,
    material: materials['Component.WhiteObjects'],
    position: [0.5, 5, 2.8],
    rotation: [-Math.PI / 2, 0, -Math.PI / 2]
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['04_horizontal_box'].geometry,
    material: materials['Component.WhiteDefault'],
    position: [0.5, 5, 2.8],
    rotation: [-Math.PI / 2, 0, -Math.PI / 2]
  }, shadows)), activeCable === _constants.activeCableDirection.vertical && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['11_horizontal_connectors'].geometry,
    material: materials['Component.WhiteDefault'],
    rotation: [-Math.PI / 2, -Math.PI / 2, 0]
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['12_horizontal_cables'].geometry,
    material: materials['Component.BodyBlack'],
    position: [0, 2.6, -0.8],
    rotation: [-Math.PI / 2, 0, -Math.PI / 2]
  }, shadows))));
};
exports.DoubleTemperatureSensorModelContent = DoubleTemperatureSensorModelContent;
DoubleTemperatureSensorModelContent.propTypes = {
  activeCable: _propTypes.default.oneOf([_constants.activeCableDirection.horizontal, _constants.activeCableDirection.vertical]),
  deviceRotate: _Types.VectorType,
  thingPDIDDevice: _propTypes.default.string
};
const DoubleTemperatureSensorModel = exports.DoubleTemperatureSensorModel = (0, _reactErrorBoundary.withErrorBoundary)(DoubleTemperatureSensorModelContent, {
  FallbackComponent: () => null,
  onError: (err, info) => console.error(err, info)
});